export const TENANT_IDS = {
    DGE_ERP: 'DGES_ERP',
    COCO: 'COCO_ERP',
    TEST_ERP: 'TEST_ERP',
}